import type { PendingObjectiveAssignmentGroupVM } from "@shared-kernel/application/ports/student/student-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const studentRetrievePendingObjectiveAssignments = createApiThunk<PendingObjectiveAssignmentGroupVM[], void>(
  "student/studentRetrievePendingObjectiveAssignments",
  async (_: void, { extra: { studentRepository } }) => {
    return studentRepository!.getPendingObjectiveAssignments();
  },
);
